
import { showMask, hideMask } from './components.recipes-mask';
import { mmMatches } from '../utils/utils.matchmedia';

const 	$ = jQuery;

const 	filters = document.querySelector('.js-recipe-filter-wrapper'),
		filterResults = document.querySelector('.js-recipes-filter-results'),
		scrollButton = document.querySelector('.js-scroll-to-results');

function scrollToResults() {
	window.scrollTo({
		top: filterResults.getBoundingClientRect().top + window.scrollY,
		left: 0,
		behavior: 'smooth'
	});
}

if ( filters ) {

	$(document).on('facetwp-refresh', function() {
	    showMask();
	});

	$(document).on('facetwp-loaded', function() {
	    hideMask();
	});
}

if ( scrollButton ) {
	scrollButton.addEventListener('click', e => {
		e.preventDefault();
		scrollToResults();
	});
}